module.exports = "pegasus/assets/themelp1/basic/106.png";